import React from 'react';
import ModelCard from './ModelCard';

/**
 * ModelsGrid Component
 * Displays models in a responsive grid layout
 */
function ModelsGrid({ models, onCardClick, onOpenContextMenu }) {
  if (models.length === 0) {
    return (
      <div className="desktop-models-grid-empty">
        <div className="desktop-empty-icon">
          <i className="fa-solid fa-brain"></i>
        </div>
        <h3>No Models Found</h3>
        <p>No models match your current filters.</p>
      </div>
    );
  }

  return (
    <div className="desktop-models-grid">
      {models.map(model => (
        <ModelCard
          key={model.id}
          model={model}
          onCardClick={onCardClick}
          onOpenContextMenu={onOpenContextMenu}
        />
      ))}
    </div>
  );
}

export default ModelsGrid;